import CryptoJS from 'crypto-js';

export function generateSha512Hash(plainText) {
    const hash = CryptoJS.SHA512(plainText);
    return hash.toString(CryptoJS.enc.Base64); // Convert hash to Base64 string
}